import { promisedRequest } from './helpers.js'

// Keyword filters kept on the server, shared by all the user's apps.

const FILTERS_URL = '/api/v1/filters'
const FILTER_URL = (id) => `${FILTERS_URL}/${id}`

export const fetchFilters = ({ credentials }) =>
  promisedRequest({ url: FILTERS_URL, credentials })

// filter: { phrase, context, whole_word, irreversible, expires_in }
export const createFilter = ({ credentials, filter }) =>
  promisedRequest({
    url: FILTERS_URL,
    method: 'POST',
    credentials,
    payload: filter,
  })

export const updateFilter = ({ credentials, id, filter }) =>
  promisedRequest({
    url: FILTER_URL(id),
    method: 'PUT',
    credentials,
    payload: filter,
  })

export const deleteFilter = ({ credentials, id }) =>
  promisedRequest({ url: FILTER_URL(id), method: 'DELETE', credentials })
